<template>
    <div class="page-static-desc-uniq">
        <blockquote v-html="options[0].title" v-if="options.length > 0"></blockquote>
        <div class="page-static-info">
            <div class="btn-to-call-center btn-form btn-to-call-bazisclub">
                <a href="#" @click.prevent="getConsultation()">ЗАКАЗАТЬ КОНСУЛЬТАЦИЮ</a>
            </div>
            <div class="btn-to-contacts btn-form">
                <router-link :to="{name: 'contacts-sales'}" @click.native="startLoader()">ОФИСЫ ПРОДАЖ КОМПАНИИ</router-link>
            </div>
            <div class="phone" v-if="currentCityArr != null">
                <svg-icon icon-class="mobile" className="share-icon icon-mobile"/>
                <a :href="'tel:' + currentCityArr[0].region_phone">
                    {{currentCityArr[0].region_phone}}
                </a>
            </div>
            <div class="instagram">
                <a href="https://www.instagram.com/bazis.kz/" target="_blank">
                    <svg-icon icon-class="instagram" className="share-icon icon-instagram"/>
                    <b>@bazis.kz</b>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'desc-uniq',
        props: ['options'],
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            currentCityArr: 'loadCurrentCityArr',
        }),
        methods: {
            getConsultation() {
                var data = {
                    'city': this.currentCityArr[0].region,
                    'page': this.options[0].data_page,
                    'page_key': this.options[0].data_page_key,
                }
                this.$store.commit('getFormConsultData', data);
                this.$store.commit('Open_form_Consult', true);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
                // console.log(data);
            },
            startLoader() {
                this.$parent.$parent.$refs.topProgress.start();
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>